@if (attachment) {
    <div class="attachment" [ngClass]="{ 'is-selected-div': selected }" (click)="onSelectFile(attachment)">
        @if (getFileType(attachment) === FileType.Email) {
            <mat-icon>email</mat-icon>
        } @else if (getFileType(attachment) === FileType.PDf) {
            <mat-icon>picture_as_pdf</mat-icon>
        }
        <p class="attachment-name" [matTooltip]="attachment.name" matTooltipPosition="below">{{ attachment.name }}</p>
        @if (readonly === false) {
            @if (attachment.isFavorite) {
                <fa-icon
                    [icon]="favorite"
                    class="favorite-icon"
                    matTooltip="Retirer des favoris"
                    matTooltipPosition="below"
                    (click)="$event.stopPropagation(); onToggleFavorite(attachment, false)"></fa-icon>
            } @else {
                <fa-icon
                    [icon]="nonfavorite"
                    class="nonfavorite-icon"
                    matTooltip="Ajouter aux favoris"
                    matTooltipPosition="below"
                    (click)="$event.stopPropagation(); onToggleFavorite(attachment, true)"></fa-icon>
            }
        }
    </div>
}
